export enum HolidayCountryType {
  NONE = 0,
  ROMANIA = 1,
  GEORGIA = 2,
  BOTH = 3,
}

export interface DayProject {
  projectId: string;
  projectName: string;
  clientName: string;
  color: string;
  durationMinutes: number;
}

export interface DayUser {
  userId: string;
  fullName: string;
  durationMinutes: number;
}

export interface Day {
  date: string;
  totalDurationMinutes: number;
  projects: DayProject[];
  holidayCountryTypes: HolidayCountryType;
  users: DayUser[];
}

export interface ProjectBreakdown {
  projectId: string;
  projectName: string;
  clientName: string;
  color: string;
  durationMinutes: number;
  users: DayUser[];
}

export interface UserBreakdown {
  userId: string;
  fullName: string;
  durationMinutes: number;
  pendingTimeOffDays: number;
  approvedTimeOffDays: number;
  projects: DayProject[];
}

export interface SummaryReportDTO {
  startDate: string;
  endDate: string;
  totalDurationMinutes: number;
  totalEntries: number;
  days: Day[];
  projectBreakdown: ProjectBreakdown[];
  userBreakdown: UserBreakdown[];
  workingDaysRomania: number;
  workingDaysGeorgia: number;
}

export interface BarDataItem {
  date: string;
  holidayType: HolidayCountryType;
  [key: string]: string | number | HolidayCountryType | undefined;
}

export interface SummaryReportPayload {
  startDate: string;
  endDate: string;
  projectIds: string[];
  employeeIds: string[];
}

export interface DetailedReportHeaderDTO {
  startDate: string;
  endDate: string;
  totalDurationMinutes: number;
}

export interface DetailedReportEntry {
  sessionId: string;
  userId: string;
  firstName: string;
  lastName: string;
  projectId: string;
  projectName: string;
  clientName: string;
  description: string;
  start: string;
  end: string;
  durationMinutes: number;
  projectColor: string;
}

export interface DetailedReportEntriesDTO {
  items: DetailedReportEntry[];
  totalCount: number;
}

export interface DetailedReportPayload {
  startDate: string;
  endDate: string;
  projectIds: string[];
  employeeIds: string[];
}

export interface ProjectsListItemDTO {
  id: string;
  name: string;
  color: string;
  clientName: string;
}

export type ProjectListDTO = ProjectsListItemDTO[];

export interface UsersListItemDTO {
  id: string;
  firstName: string;
  lastName: string;
}

export type UsersListDTO = UsersListItemDTO[];
